import rocklee from '../../assets/images/rockLee.png';
import { styled } from "styled-components";
import { Name } from '../common/gradientProps';
import { useState } from 'react';

const RockleeAndQuote = styled.img`
    max-height: 358px;
    max-width: 245px;
      // border: 1px solid ${({ theme }) => theme.circularIconBg};
`;

const RockLeePlaceholder = styled.div`
  min-width: 358px;
  min-height: 250px;
  border-radius: 9px;
  border: 1px solid ${({theme}) => theme.text};
`;

const QuoteText = styled.p`
  bottom: 10px;
  right: 10px;
  margin: 0;
  color: ${({ theme }) => theme.circularIconBg};
  
`;

const inlineHeadQuote = {
    fontWeight: '200',
    display: 'block',
    marginBottom: '1rem',
}

const quoteDiv = {
    marginTop: '-5.5rem',
    marginLeft: '6rem',
}

function RockLee() {
  const [imageLoaded, setImageLoaded] = useState(true);

  const handleImageError = () => {
    setImageLoaded(false); // Switch to placeholder if the image fails to load
};
    return(
       <div style={{margin: '10rem 0'}} className='d-flex justify-content-center align-items-center'>
          <div>
            {
              imageLoaded? (<RockleeAndQuote src={rocklee} alt='Rock Lee' onError={handleImageError} />):
              (<RockLeePlaceholder />)
            }
          
            <div style={quoteDiv}>
            <QuoteText>
               <span style={inlineHeadQuote}><Name style={{ fontWeight: '900'}}>F</Name>avourite quote</span>
                <span style={{fontWeight: 200}}>Be water my friend!</span>
             </QuoteText>
            </div>
          </div>
       </div>
    )
}

export default RockLee